module.exports = __webpack_public_path__ + "static/media/gryphon-news.2acb5ccc.jpg";